module.exports = __webpack_public_path__ + "img/bezel.9c985bb3.svg";